__turbopack_context__.v({
  "container": "CartQuantityPicker-module-scss-module__9RVUyG__container",
  "loading": "CartQuantityPicker-module-scss-module__9RVUyG__loading",
  "price": "CartQuantityPicker-module-scss-module__9RVUyG__price",
  "qty": "CartQuantityPicker-module-scss-module__9RVUyG__qty",
  "qtyChanger": "CartQuantityPicker-module-scss-module__9RVUyG__qtyChanger",
  "qtyChangerAdd": "CartQuantityPicker-module-scss-module__9RVUyG__qtyChangerAdd",
  "qtyChangerContainer": "CartQuantityPicker-module-scss-module__9RVUyG__qtyChangerContainer",
  "qtyChangerDisabled": "CartQuantityPicker-module-scss-module__9RVUyG__qtyChangerDisabled",
  "sub": "CartQuantityPicker-module-scss-module__9RVUyG__sub",
  "title": "CartQuantityPicker-module-scss-module__9RVUyG__title",
  "visuallyHidden": "CartQuantityPicker-module-scss-module__9RVUyG__visuallyHidden",
});
